/**
 * FormSectionCard - Card reutilizável para seções do formulário premium
 * Segue o padrão visual do DealDetailsModalPremium
 */
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FormSectionCardProps {
  title?: string;
  icon?: LucideIcon;
  children: React.ReactNode;
  className?: string;
  compact?: boolean;
}

export function FormSectionCard({ 
  title, 
  icon: Icon, 
  children, 
  className,
  compact = false
}: FormSectionCardProps) {
  return (
    <div className={cn(
      "bg-muted/30 border border-border/40 rounded-xl transition-colors",
      compact ? "p-3" : "p-4",
      className
    )}>
      {title && (
        <div className="flex items-center gap-2 mb-3">
          {Icon && (
            <div className="flex items-center justify-center w-6 h-6 rounded-md bg-primary/10">
              <Icon className="w-3.5 h-3.5 text-primary" />
            </div>
          )}
          <span className="text-[11px] uppercase tracking-wider text-muted-foreground font-semibold">
            {title}
          </span>
        </div>
      )}
      <div className="space-y-3">
        {children}
      </div>
    </div>
  );
}
